var clipboard = new ClipboardJS('.clipboard-copy');
